import React, { useEffect, useState, useRef } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Button } from 'primereact/button';


export const TableDetail = ({
    // data task
    ref,
    rowData,
    data,
    tableColumns,
    loading = true,
    dataKey,

    ...rest
}) => {
    /**@data => state for table data*/
    /**@loading => loading state=> true / false*/
    /**@tableColumns => tableColumns you want*/

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (typeof data === "undefined" || data === null) {
            return setTableData([]);
        }
        setTableData(data);
    }, [data]);

    const exportColumns = tableColumns.map((col) => ({ title: col.header, dataKey: col.field }));

    const exportPdf = () => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                doc.autoTable(exportColumns, data);
                doc.save(rowData?.name ? rowData?.name + '-' + rowData?.emp_id + '-' + 'assets' : 'Table_export.pdf');
            });
        });
    };

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(data);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, rowData?.name ? rowData?.name + '-' + rowData?.emp_id + '-' + 'assets' : 'Table_export');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + EXCEL_EXTENSION);
            }
        });
    };

    const header = (
        <div className="flex align-items-center justify-content-end gap-2">
            <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} />
            <Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} />
        </div>
    );

    return (
        <>
            <div className="datatable-filter-demo">
                <div className="card">
                    <DataTable
                        className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers"
                        ref={ref}
                        header={header}
                        value={tableData}
                        dataKey={dataKey}
                        loading={loading}
                        emptyMessage="Sorry, no matching records found !!!"
                        {...rest}
                    >

                        {tableColumns?.map((col, i) => (
                            <Column key={i} 
                                field={col.field} 
                                header={col.header} 
                                body={col.sortableBody}
                                style={{ minWidth: col.minWidth }} 
                            />
                        ))}
                    </DataTable>
                </div>
            </div>
        </>

    );
};
